module.exports = __webpack_public_path__ + "img/homeApplicationBannerr.56c5923.png";